import React from "react";
import Contract from "./Contract";
import Permanent from "./Permanent";

const JobTypeActiveContent = (props) => {
  const {
    jobType,
    salaryMin,
    salaryMax,
    handleTextInput,
    salaryType,
    handleSalaryType,
    currency,
    errors,
  } = props;

  let activeContent;

  switch (jobType) {
    case "contract":
      activeContent = (
        <Contract
          salaryMin={salaryMin}
          handleTextInput={handleTextInput}
          currency={currency}
          errors={errors}
        />
      );
      break;
    default:
      activeContent = (
        <Permanent
          salaryMin={salaryMin}
          salaryMax={salaryMax}
          handleTextInput={handleTextInput}
          salaryType={salaryType}
          handleSalaryType={handleSalaryType}
          currency={currency}
          errors={errors}
        />
      );
  }

  return activeContent;
};

export default JobTypeActiveContent;
